import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import AdminConfigurations from 'src/components/admin/Configurations';
import AdminSpecializations from 'src/components/admin/Specializations';
import PoliciesTable from 'src/components/admin/PoliciesTable';

const ConfigPage = () => {
  const Item = styled(Paper)(({ theme, spacing }) => ({
    backgroundColor: 'white',
    ...theme.typography.body2,
    padding: theme.spacing(3),
    textAlign: 'center',
    color: 'black',
    borderColor: 'grey',
    '& > *': {
      marginBottom: spacing + 'rem'
    }
  }));

  return (
    <Box sx={{ flexGrow: 1 }} paddingX={4}>
      <Grid container spacing={2} rowSpacing={3}>
        <Grid item xs={12} md={6}>
          <Item style={{ height: '21rem' }}>
            <AdminConfigurations />
          </Item>
        </Grid>
        <Grid item xs={12} md={6}>
          <Item style={{ height: '21rem' }}>
            <AdminSpecializations />
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <PoliciesTable />
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConfigPage;
